import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import { selectSeriesInfoForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { SameSeries } from '.';

export class SameSeriesContainer extends React.PureComponent {
  render() {
    return <SameSeries {...this.props} />;
  }
}

SameSeriesContainer.propTypes = {
  open: PropTypes.bool,
  series: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape
};

const mapStateToProps = state => {
  return {
    series: selectSeriesInfoForCurrentBib(state),
    catalogBib: selectCatalogBib(state)
  };
};

export default connect(mapStateToProps)(SameSeriesContainer);
